import { useState } from 'react';
import { Textarea, ToggleGroup, ToggleGroupItem } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import type { SchemaWidgetProps } from '@/shared/ui/SchemaForm';

type Mode = 'edit' | 'preview';

export function HtmlTemplateWidget({ id, value, onChange, disabled, hasError }: SchemaWidgetProps) {
  const { t } = useTranslation('admin');

  const [mode, setMode] = useState<Mode>('edit');
  const htmlValue = String(value ?? '');

  return (
    <div className="flex flex-col gap-2">
      <ToggleGroup
        type="single"
        size="sm"
        value={mode}
        onValueChange={(next) => {
          if (next === 'edit' || next === 'preview') setMode(next);
        }}
        className="self-end"
      >
        {/* eslint-disable i18next/no-literal-string -- toggle option value attributes */}
        <ToggleGroupItem value="edit">{t('admin.htmlTemplateWidget.edit')}</ToggleGroupItem>
        <ToggleGroupItem value="preview">{t('admin.htmlTemplateWidget.preview')}</ToggleGroupItem>
        {/* eslint-enable i18next/no-literal-string */}
      </ToggleGroup>

      {mode === 'edit' ? (
        <Textarea
          id={id}
          className="min-h-40 font-mono"
          value={htmlValue}
          disabled={disabled}
          aria-invalid={hasError || undefined}
          onChange={(event) => onChange(event.target.value)}
        />
      ) : (
        <div className="min-h-40 overflow-hidden rounded-md border border-border bg-background">
          <iframe
            srcDoc={htmlValue}
            title={t('admin.htmlTemplateWidget.htmlPreview')}
            sandbox=""
            className="min-h-40 w-full border-0"
          />
        </div>
      )}
    </div>
  );
}
